import { fromJS } from 'immutable';
import * as constants from './constants';

//初始化数据
const defaultState = fromJS({

    login: false, // 登录

    pictureCode: null, // 图片验证
});

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = defaultState, action) => {
    switch (action.type) {
        //登录
        case constants.LOGIN_DATA:
            return state.set('login', action.login);

        //图片验证码
        case constants.PICTRUE_CODE:
            return state.set('pictureCode', action.value);

        default:
            return state;
    }
};
